import { Depot } from "./Depot";
import { Place } from "./Place";
import { RouteSegment } from "./RouteSegment";
import { Currency } from "./Currency";
import { Unit } from "./Unit";
import { PackingType } from "./PackingType";

// Modelo principal (con entidades)
export interface WarehouseExpedition {
    id?: number;
    quote_id?: number;

    depot?: Depot;
    depot_id?: number;

    place?: Place;
    place_id?: number;

    origin?: string;
    origin_id?: number;


    destiny?: string;
    destiny_id?: number;
    route_segment?: RouteSegment;
    route_segment_id?: number;

    packing_type?: PackingType;
    rate?: number;

    currency?: Currency;
    currency_id?: number;

    unit?: Unit;
    unit_id?: number;

    created_at?: string;
    updated_at?: string;
}

// Modelo para uso en formularios
export interface WarehouseExpeditionDataForm {
    id?: number;
    quote_id?: number;

    depot?: Depot;
    depot_id?: number;

    place?: Place;
    place_id?: number;

    origin?: string;
    origin_id?: number;
    destiny?: string;
    destiny_id?: number;
    route_segment?: RouteSegment;
    route_segment_id?: number | null;

    container_type?: string;
    rate?: number;

    currency?: Currency;
    currency_id?: number;

    unit?: Unit;
    unit_id?: number;

    packing_type?: PackingType;
    packing_type_id?: number;

    created_at?: string;
    updated_at?: string;
}
export interface WarehouseExpeditionShowDataForm {
    id?: number;
    quote_id?: number;

    depot?: string;
    depot_id?: number;

    place?: Place;
    place_id?: number;

    origin?: string;
    origin_id?: number;
    destiny?: string;
    destiny_id?: number;
    route_segment?: RouteSegment;
    route_segment_id?: number;

    container_type?: string;
    rate?: number;

    currency?: string;
    currency_id?: number;

    unit?: string;
    unit_id?: number;

    packing_type?: string;
    packing_type_id?: number;

    created_at?: string;
    updated_at?: string;
}

export const defaultWarehouseExpeditionDataForm: WarehouseExpeditionDataForm = {
    id: undefined,
    depot_id: undefined,
    place_id: undefined,
    route_segment_id: undefined,
    container_type: '',
    rate: 0,
    currency_id: undefined,
    unit_id: undefined
};

// Filtros para paginación/tablas
export interface WarehouseQuoteExpeditionFilters {
    page: number;
    per_page: number;
    sort: string;
    order: string;
}
